import moment from "moment";

const getDate = (date) => moment(date).format("DD/MM/yyyy");

const getDefDate = (date) => moment(date).format("YYYY-MM-DD");

export {
    getDate,
    getDefDate
}